<template>
  <div class="content-main">
    <div class="content">
      <UploadInfoComponent v-model="showFileInfo" :info="selectedFileInfo" />
      <div class="header">
        {{ $t("message.uploads.title") }}
        <button class="btn-info-button" @click="showUploadComponent()">
          {{ $t("message.uploads.upload_new_file") }}
        </button>
        <button class="btn-dark-button" @click="loadFiles()">
          {{ $t("message.uploads.refresh_page") }}
        </button>
        <UploadComponent
          v-model="displayUploadComponent"
          @uploadedFile="addUploadedFile"
        />
      </div>
      <div class="table" v-if="!loading">
        <table class="default-table">
          <thead>
            <tr class="table100-head">
              <th>
                {{ $t("message.uploads.file_name") }}
              </th>
              <th>
                {{ $t("message.uploads.type") }}
              </th>
              <th>
                {{ $t("message.uploads.upload_date") }}
              </th>
              <th>
                {{ $t("message.uploads.status") }}
              </th>
              <th>
                {{ $t("message.uploads.user") }}
              </th>
              <th>
                {{ $t("message.uploads.action") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="file in files" :key="file.id">
              <td>
                {{ file.fileName }}
              </td>
              <td>
                {{ file.category }}
              </td>
              <td>
                {{ file.date | dateWithHours }}
              </td>
              <td>
                {{ file.status }}
              </td>
              <td>
                {{ file.userName }}
              </td>
              <td class="action-box">
                <a class="icon-link" @click="getFileInfo(file.id)">
                  <img
                    class="icon"
                    src="@/assets/icons/information.svg"
                    alt="Information"
                  />
                </a>
                <a
                  class="icon-link"
                  @click="downloadFile(file.s3Path, file.s3Url)"
                >
                  <img
                    class="icon"
                    src="@/assets/icons/download.svg"
                    alt="Download"
                  />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <BaseSmallSpinner />
      </div>
    </div>
  </div>
</template>
<script>
import {
  getUploadedFiles,
  getUploadedFileInfo,
  signAndDownloadFile
} from "@/api/store/UploadFilesService.js";
import UploadComponent from "@/components/UploadComponent.vue";
import UploadInfoComponent from "@/components/UploadInfoComponent.vue";

export default {
  name: "UploadPage",
  components: {
    UploadComponent,
    UploadInfoComponent
  },
  data() {
    return {
      files: [],
      displayUploadComponent: false,
      loading: true,
      selectedFileInfo: {},
      showFileInfo: false
    };
  },
  mounted() {
    this.loadFiles();
  },
  methods: {
    loadFiles() {
      this.loading = true;
      getUploadedFiles({})
        .then(res => {
          this.files = res;
          this.loading = false;
        })
        .catch(e => {
          console.log(e.response);
          this.loading = false;
        });
    },
    showUploadComponent() {
      this.displayUploadComponent = true;
    },
    addUploadedFile(file) {
      this.files.unshift(file);
    },
    getFileInfo(uploadId) {
      this.showFileInfo = false;
      getUploadedFileInfo(uploadId)
        .then(res => {
          this.selectedFileInfo = res;
          this.showFileInfo = true;
        })
        .catch(() => {
          this.$toast.open({
            message: `Error loading info`,
            type: "error",
            position: "top-right"
          });
        });
    },
    async downloadFile(key, s3Url) {
      console.log("s3Path", key);
      const res = await signAndDownloadFile(key, s3Url);
      console.log("res", res);
      if (!res) {
        this.$toast.open({
          message: `Error Downloading file`,
          type: "error",
          position: "top-right"
        });
      }
      return;
    }
  }
};
</script>
<style lang="scss" scoped>
.action-box {
  display: flex;
  flex-direction: row;
  .icon-link {
    display: flex;
    margin: 0px 5px;
    .icon {
      width: 20px;
      margin: auto 0;
    }
  }
}
</style>
